import { inject } from 'mobx-react'
import * as React from 'react'
import { Navigate } from 'react-router-dom'
import { IOrganization, IUser } from '../../Definitions'
import { IStores } from '../../Stores'
import IRoute from '../IRoute'
import RedirectWithErrorMessage from '../RedirectWithErrorMessage'
import Constants from '../../config'
import { OrganizationId } from 'src/utils/OrganizationIds'

interface IRoleRequiredRouteProps {
  currentAppOrganization?: IOrganization
  route: IRoute
  user?: IUser
}

const RoleRequiredRoute: React.FC<IRoleRequiredRouteProps> = (props) => {
  const { currentAppOrganization, route, user } = props

  if (!user) {
    return <Navigate to="/login" replace />
  }

  const allowedRoles = route.allowedRoles ? route.allowedRoles : []
  const allowedOrganizations = route.allowedOrganization ? route.allowedOrganization : []
  const userRoles = user.roles
  const isInAllowedRole =
    allowedRoles.length === 0 ||
    allowedRoles.some((x: string) => userRoles.indexOf(x) > -1)
  const isInAllowedOrganization =
    allowedOrganizations.length === 0 ||
    allowedOrganizations.some(
      (o) => o === (currentAppOrganization ? currentAppOrganization.id : undefined)
    )

  const redirectPath =
    currentAppOrganization?.id === OrganizationId.Surgical &&
    (userRoles.includes(Constants.ObxRoles.CareCoordinator) ||
      userRoles.includes(Constants.ObxRoles.CareCoordinatorManager))
      ? '/'
      : currentAppOrganization?.id === OrganizationId.Surgical
        ? '/patients'
        : currentAppOrganization?.id === OrganizationId.Medical
          ? '/Cases'
          : '/workflow-inboxes'

  if (isInAllowedRole && isInAllowedOrganization) {
    const Component = route.component
    return <Component />
  } else {
    // User IS logged in but doesn't have the right permissions
    return (
      <RedirectWithErrorMessage
        messageId="routeRequiresRole"
        message="Your account or organization is not permitted on that page."
        redirectTo={redirectPath}
      />
    )
  }
}

const InjectedRoleRequiredRoute = inject<
  IStores,
  IRoleRequiredRouteProps,
  Partial<IRoleRequiredRouteProps>,
  any
>((stores: IStores) => ({
  currentAppOrganization: stores.global.currentAppOrganization,
  user: stores.global.user,
}))(RoleRequiredRoute)

export default InjectedRoleRequiredRoute
